<template>
    <section>
        <div class="row">
            <div class="col-3">
                <h5 class="pb-3">Validate GSTIN</h5>
                <form>

                  <b-form-group label="GSTIN">
                    <b-textarea v-model="gstins" placeholder="One Per Line" rows="10"></b-textarea>
                  </b-form-group>

                  <b-button @click.prevent="validate" variant="primary"><i class="fa fa-check"></i> Validate</b-button>
                </form>
            </div>

            <div class="col-9">

              <div class="row mb-3">
                <div class="col-3">
                  <h4 class="form-head">Results</h4>
                </div>
                <div class="col-9 text-right">
                  <div class="btn-group">
                    <button class="btn btn-primary" @click.prevent="excel"><i class="fa fa-download"></i> Excel</button>
                    <button class="btn btn-warning" @click.prevent="clear"><i class="fa fa-times"></i> Clear</button>
                  </div>
                </div>
                <div class="col-12">

                  <table class="table table-striped table-sm mt-3">
                    <thead class="thead-dark">
                    <tr>
                      <th>GSTIN</th>
                      <th>Name</th>
                      <th>Address</th>
                      <th>Valid?</th>
                      <th>Cancelled?</th>
                    </tr>
                    </thead>
                    <tbody>
                    <tr v-for="f of validations" :key="f.gstNumber">
                      <td>{{f.gstNumber}}</td>
                      <td>{{f.name}}</td>
                      <td>{{f.address}}</td>
                      <td>{{f.valid}}</td>
                      <td>{{f.cancelled}}</td>
                    </tr>
                    </tbody>
                  </table>
                </div>
              </div>
            </div>
        </div>
    </section>
</template>
<script>
import axios from 'axios'
import moment from 'moment'
import Loading from './shared/Loading'

export default {
  name: 'ValidatePage',
  components: {Loading},
  data () {
    return {
      validations: [],
      gstins: ''
    }
  },
  methods: {
    validate: function () {
      let gstins = this.gstins.split('\n')
      let oldGstins = this.validations.map(v => v.gstNumber)
      let newGstins = gstins.filter(g => oldGstins.indexOf(g) === -1)
      newGstins.forEach(g => {
        axios.get(`https://api.e-waybill.in/api/gstin/validate?gstin=${g}`)
          .then(resp => {
            this.validations.unshift(resp.data)
          }, err => {
            console.error('error in validating of gstin', err)
          })
      })
      this.gstins = ''
    },
    clear: function () {
      this.validations = []
    },
    excel: function () {
      let rows = this.validations.map(v => `${v.gstNumber}\t${v.name}\t${v.address}\t${v.valid}\t${v.cancelled}`)
      rows.unshift('GST Number, Name, Address, Valid?, Cancelled?')
      let csvContent = 'data:text/csv;charset=utf-8,' + rows.join('\r\n')
      let encodedUri = encodeURI(csvContent)
      let link = document.createElement('a')
      link.setAttribute('href', encodedUri)
      link.setAttribute('download', `Validate_${moment().format('YYYY-MM-DD')}.xls`)
      document.body.appendChild(link) // Required for FF

      link.click() // This will download the data file named "my_data.csv".
    }
  },
  created: function () {
  }
}
</script>



// WEBPACK FOOTER //
// src/components/ValidatePage.vue